import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './screen-blur-overlay.module.scss';
import classNames from 'classnames';

const ScreenBlurOverlay = ({ isVisible }: { isVisible: boolean }) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [shouldMount, setShouldMount] = useState(false);
  const showTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const mountTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Clear any existing timeouts
    if (showTimeoutRef.current) {
      clearTimeout(showTimeoutRef.current);
      showTimeoutRef.current = null;
    }
    if (mountTimeoutRef.current) {
      clearTimeout(mountTimeoutRef.current);
      mountTimeoutRef.current = null;
    }

    if (isVisible) {
      setShouldMount(true);
      showTimeoutRef.current = setTimeout(() => {
        setShouldShow(true);
        showTimeoutRef.current = null;
      }, 100);
    } else {
      setShouldShow(false);
      mountTimeoutRef.current = setTimeout(() => {
        setShouldMount(false);
        mountTimeoutRef.current = null;
      }, 300);
    }
  }, [isVisible]);

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (showTimeoutRef.current) {
        clearTimeout(showTimeoutRef.current);
      }
      if (mountTimeoutRef.current) {
        clearTimeout(mountTimeoutRef.current);
      }
    };
  }, []);

  if (!shouldMount) return null;

  return createPortal(
    <div
      className={classNames(styles.blurOverlay, {
        [styles.visible]: shouldShow,
      })}
    />,
    document.body,
  );
};

export default ScreenBlurOverlay;
